import decode from "jwt-decode";
import http from "../plugins/http";

const state = {
  token: "",
  level: "",
  user: {
    id: "",
    name: "",
    email: "",
  },
};

const mutations = {
  setToken(state, value) {
    state.token = value.token;
  },
  setUserLevel(state, value) {
    state.level = value;
  },
  setUserInfo(state, value) {
    state.user = value;
  },
};

const getters = {
  isAuth(state) {
    return !!state.token;
  },
  userPermission(state) {
    return function verifyPermission(permissions) {
      return !permissions.includes(state.level);
    };
  },
};

const actions = {
  async login({ commit }, { email, password }) {
    try {
      const { data } = await http.post("auth/login", { email, password });
      http.defaults.headers.common.Authorization = `Bearer ${data.token}`;

      const { permission } = decode(data.token);
      const { data: userInfo } = await http.get("user/me");

      commit("setToken", data);
      commit("setUserLevel", permission);
      commit("setUserInfo", userInfo);
    } catch (err) {
      commit(
        "setToastedError",
        { message: err.response.data.error },
        { root: true }
      );
    }
  },
  async logout({ commit }) {
    await http.post("auth/logout");
    http.defaults.headers.common.Authorization = "";
    commit("setToken", { token: "" });
  },
  async forgotPassword({ commit }, { email }) {
    try {
      await http.post("auth/forgot-password", { email });
      commit(
        "setToastedSuccess",
        { message: "Email enviado com sucesso" },
        { root: true }
      );
    } catch (err) {
      commit(
        "setToastedError",
        { message: err.response.data.error },
        { root: true }
      );
    }
  },
  async changePass({ commit }, { form, token }) {
    try {
      await http.post(`auth/change/${token}`, form);
      commit(
        "setToastedSuccess",
        { message: "Senha alterada com sucesso" },
        { root: true }
      );
    } catch (err) {
      commit(
        "setToastedError",
        { message: err.response.data.error },
        { root: true }
      );
    }
  },

  async refresh({ commit, state }) {
    try {
      const { data } = await http.post("auth/refresh");
      http.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      const { permission } = decode(data.token);

      if (!state.user.id) {
        const { data: userInfo } = await http.get("user/me");
        commit("setUserInfo", userInfo);
      }

      commit("setToken", data);
      commit("setUserLevel", permission);
    } catch (err) {
      console.log(err);
    }
  },

  async changePassLoggedin({ commit }, value) {
    try {
      const { data } = await http.post("auth/change-password", value);
      http.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      const { permission } = decode(data.token);

      commit("setToken", data);
      commit("setUserLevel", permission);
      commit(
        "setToastedSuccess",
        { message: "Senha alterada com sucesso" },
        { root: true }
      );
    } catch (err) {
      commit(
        "setToastedError",
        { message: "Não foi possível alterar a senha" },
        { root: true }
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
